import React from 'react';
import { useNavigate } from 'react-router-dom';
import WellnessInput from '../WellnessInput';
import MobileWellnessWizard from './MobileWellnessWizard';
import MobileRPEWizard from './MobileRPEWizard';

const BACK_BTN = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 6,
  padding: '8px 14px',
  borderRadius: 10,
  border: '1px solid var(--border-strong)',
  background: 'var(--bg-card)',
  color: 'var(--text-secondary)',
  fontSize: 13,
  fontWeight: 600,
  cursor: 'pointer',
  fontFamily: 'inherit',
  marginBottom: 20,
};

export default function PlayerWellness({ playerRecord, defaultTab = 'wellness', sessionType = 'pitch', isMobile }) {
  const navigate = useNavigate();

  if (isMobile && defaultTab === 'rpe') {
    return <MobileRPEWizard playerRecord={playerRecord} sessionType={sessionType} />;
  }
  if (isMobile) {
    return <MobileWellnessWizard playerRecord={playerRecord} />;
  }

  return (
    <div style={{ padding: 16 }}>
      <button onClick={() => navigate('/player/forms')} style={BACK_BTN}>
        ← Back
      </button>
      <WellnessInput
        playerOverride={playerRecord}
        defaultTab={defaultTab}
        sessionType={sessionType}
        hideTabs={['history']}
      />
    </div>
  );
}
